<template>
  <div class="_pages">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "pages",
  componentName: "pages",
  provide() {
    return {
      pagesSup: this,
    };
  },
  watch: {
    index: function () {
      this.hidePage();
      this.showPage();
    },
  },
  props: {
    index: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      pages: [],
      lastPage: "",
    };
  },
  created() {
    let _this = this;
    this.$store.subscribe((mutation, esPages) => {
      _this.pages = esPages.esPages;
    });
    _this.lastPage = _this.index;
  },
  mounted() {},
  methods: {
    hidePage() {
      let _this = this;
      _this.pages[_this.lastPage].hidePage();
    },
    showPage() {
      let index = this.index;
      let pages = this.pages;
      pages[index].showPage();
      this.lastPage = index;
    },
  },
};
</script>

<style>
._pages {
  height: 100%;
  width: 100%;
}

._show {
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>